import { Controller } from "@hotwired/stimulus"

// Toggles the calendar logo placeholder between square (rounded-3) and circle
// (rounded-circle) classes when the Widget Shape radio changes — purely
// presentational; the radio's value is what persists on submit.
export default class extends Controller {
  static targets = ["preview"]

  setShape(event) {
    const shape = event.currentTarget.dataset.shape
    if (!this.hasPreviewTarget) return

    this.previewTarget.classList.remove("rounded-3", "rounded-circle")
    this.previewTarget.classList.add(shape === "circle" ? "rounded-circle" : "rounded-3")
  }
}
